import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

const initialState = {
  userData: '',
  token: localStorage.getItem("token") || "",
  loading: 'idle', // idle, pending, failed
};

export const getUserData = createAsyncThunk("getUserDataPromise", async (data, { rejectWithValue }) => {
  const response = await fetch(process.env.REACT_APP_BASE_URL + '/emp/login', {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  })
  try {
    const result = await response.json()
    return result
  } catch (error) {
    return rejectWithValue(error);
  }
}
)


const loginSlice = createSlice({
  name: 'userData',
  initialState,

  // for empty all state after logout
  reducers: {
    setLogout(state, action) {
      // state.userData = action.payload
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getUserData.pending, (s, a) => {
        s.loading = 'pending';
      })
      .addCase(getUserData.rejected, (s, a) => {
        s.loading = 'idle';
        alert('Failed');
      })
      .addCase(getUserData.fulfilled, (s, a) => {
        s.userData = a.payload;
        s.loading = 'success';

        // token save
        const token = a.payload.token;
        s.token = token;
        localStorage.setItem("token", token);
      });
  },
});


export const { setLogout } = loginSlice.actions;
export default loginSlice.reducer;